import { Component, OnInit,Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigService } from 'src/app/utils/config/config.service';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { ProveedorService } from '../proveedor.service';

@Component({
  selector: 'app-proveedor-view',
  templateUrl: './proveedor-view.component.html',
  styleUrls: ['./proveedor-view.component.scss']
})
export class ProveedorViewComponent implements OnInit {
 
  form: FormGroup = new FormGroup({});
  estado = [{ id: 1, name: 'Activo' }, { id: -1, name: 'Inactivo' }];
  estado_seleccionado!: number;
  @Input() element: any = {};
  
  constructor(
    public formBuilder: FormBuilder,
    public config: ConfigService,
    public formatter: FormatterService,
    public service: ProveedorService,
    public activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      id:[],
      nombre: ['', [Validators.required]],
      apellido: [],
      razon_social: [],
      email: [],
      fono: [],
      fono2: [],
      estado: ['', [Validators.required]],
      direccion: [''],
    });
    this.estado_seleccionado = this.element.estado;
    this.form.patchValue(this.element);
    this.form.disable();
  }

}
